import { type Message } from '@air/wss-sdk';

type SessionUpdatedMessage = Message<'Activity.Agent.Session.updated'>;

export type WorkspaceAgentSessionUpdatedEvent = Pick<
  SessionUpdatedMessage['data'],
  'sessionId' | 'workspaceId' | 'sessionCreatedBy' | 'updates' | 'updatedAt'
>;

/** Matches UpdateAgentSessionRequest title max length in @air/server-sdk. */
export const WORKSPACE_AGENT_SESSION_TITLE_MAX_LENGTH = 255;
